const evaluateIterateMessage = ({ args, workflow, apps }) => {
  const stepId = args?.stepId;

  if (!stepId) {
    return 'Loop through app data';
  }

  const steps = workflow?.steps || [];
  let argStep = null;
  for (let i = 0; i < steps.length; i++) {
    if (steps[i]?.id === stepId) {
      argStep = steps[i];
      break;
    }
  }

  if (!argStep) {
    return 'Loop through app data';
  }

  const appId = argStep?.appId;
  if (!appId) {
    return 'Loop through app data';
  }

  const appsArr = apps || [];
  let argApp = null;
  for (let i = 0; i < appsArr.length; i++) {
    if (appsArr[i]?.id === appId) {
      argApp = appsArr[i];
      break;
    }
  }

  if (!argApp) {
    return 'Loop through app data';
  }

  const argStepActionId = argStep?.actionId;
  const appName = argApp?.name;

  if (!argStepActionId) {
    return appName ? `Loop through ${appName}` : 'Loop through app data';
  }

  const actions = argApp?.actions || [];
  let action = null;
  for (let i = 0; i < actions.length; i++) {
    if (actions[i]?.id === argStepActionId) {
      action = actions[i];
      break;
    }
  }

  const actionName = action?.name;
  if (appName && actionName) {
    return `Loop through ${appName} - ${actionName}`;
  }

  if (appName) {
    return `Loop through ${appName}`;
  }

  return 'Loop through app data';
};

export default evaluateIterateMessage;
